import { h } from 'preact';
import cx from 'classnames';
import style from './style';
import Row from '../';

export const RowNoMargin = (props) => {
	let { children } = props;

	return (
		<Row class={cx(style.rowNoMargin, props.class)}>
			{children}
		</Row>
	);
};

export default RowNoMargin;
